import { ReportHeader } from "@/components/report-header";
import { EmptyState } from "@/components/ui/empty-state";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { ViewSelector } from "@/components/view-selector";
import { SavedViewProvider } from "@/contexts/saved-view-context";
import { useChannelSelection } from "@/hooks/use-channel-selection";
import { usePageTitle } from "@/hooks/use-page-title";
import { ChannelScorecard } from "./channel-scorecard";
import { ChannelSelector } from "./channel-selector";
// Status selector moved into the report card header controls

export default function ChannelsPage() {
  const pageType = "channels::explorer";
  const { selectedChannelType } = useChannelSelection();

  // We don't need to fetch channels, only using the selection value

  // Find the selected channel by name
  const selectedChannelName = selectedChannelType;

  // Set page title using channel name
  usePageTitle(
    selectedChannelName
      ? `${selectedChannelName} - Channel Report`
      : "Channel Report Card",
  );

  return (
    <SavedViewProvider pageType={pageType}>
      <div className="flex flex-col space-y-4">
        <ReportHeader
          title="Channel Report Card"
          primary={
            <div className="flex flex-wrap gap-2">
              <ChannelSelector />
            </div>
          }
          right={
            selectedChannelType ? (
              <ViewSelector pageType={pageType} />
            ) : undefined
          }
        />

        {!selectedChannelType ? (
          <EmptyState
            title="Select a channel"
            description="Select a channel from the dropdown above to view its report card."
          />
        ) : (
          <Tabs defaultValue="scorecard" className="w-full">
            <div className="flex items-center border-b">
              <TabsList className="border-b-0">
                <TabsTrigger value="scorecard" className="relative">
                  <div className="flex items-center gap-1.5">Scorecard</div>
                </TabsTrigger>
              </TabsList>
            </div>

            <TabsContent value="scorecard" className="mt-6">
              <ChannelScorecard />
            </TabsContent>
          </Tabs>
        )}
      </div>
    </SavedViewProvider>
  );
}
